import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Search from "../../../assets/img/hb/search.svg";

export const BuscadorComponent = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [isValid, setIsValid] = React.useState(true); // longitud mínima
  const [isCharsValid, setIsCharsValid] = React.useState(true); // caracteres permitidos
  const location = useLocation();
  let pathName = location.pathname;

  // Permitir: letras a-z, A-Z, números 0-9, espacios, tildes (áéíóúÁÉÍÓÚ), ñÑ, üÜ (sin otros signos)
  const allowedRegex = /^[a-zA-Z0-9 áéíóúÁÉÍÓÚñÑüÜ]*$/;

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      const value = e.target.value || "";
      const lengthOk = value.length >= 4;
      const charsOk = allowedRegex.test(value);
      setIsValid(lengthOk);
      setIsCharsValid(charsOk);
      if (lengthOk && charsOk) {
        navigate(`/micrositio/search?query=${searchTerm}`);
      }
    }
  };

  const handleChange = (e) => {
    const value = e.target.value || "";
    setSearchTerm(value);
    // Validación en vivo (opcional): marcamos error si hay caracteres inválidos
    setIsCharsValid(allowedRegex.test(value));
    // Si escribe lo suficiente, limpiamos el error de longitud
    if (value.length >= 4 && !isValid) setIsValid(true);
  };

  return (
    <div>
      <div className="buscador-input-wrapper">
        <img src={Search} className="input-icon" alt="Buscar" />
        <input
          type="text"
          maxLength={50}
          className="buscador-input"
          placeholder="Buscar por palabra, servicio, etc"
          value={searchTerm}
          onChange={handleChange}
          onKeyDown={handleKeyDown}
        />        
      </div>
      {!isValid && (
        <span
          className={"ayudaHB-pc error-length"}
          style={
            pathName === "/micrositio/" || pathName === "/micrositio"
              ? { color: "white" }
              : { color: "#05294f" }
          }
        >
          El término a buscar debe contener 4 caracteres o más
        </span>
      )}
      {!isCharsValid && (
        <span
          className={"ayudaHB-pc error-length"}
          style={
            pathName === "/micrositio/" || pathName === "/micrositio"
              ? { color: "white" }
              : { color: "#05294f" }
          }
        >
          Usá letras, números y espacios. No se permiten símbolos.
        </span>
      )}
    </div>
  );
};
